import { render, staticRenderFns } from "./TestPerformedByAuthor.vue?vue&type=template&id=54051a0c&scoped=true&"
import script from "./TestPerformedByAuthor.vue?vue&type=script&lang=js&"
export * from "./TestPerformedByAuthor.vue?vue&type=script&lang=js&"
import style0 from "./TestPerformedByAuthor.vue?vue&type=style&index=0&id=54051a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54051a0c",
  null
  
)

export default component.exports